module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p1-B-cb33342ce3871020966e2c72e181abf3.png";